import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Box, Button, Typography } from '@mui/material';
import EmployeesListTable from './EmployeesListTable';
import EmployeesFilter from './EmployeesFilter';
import AppPagination from '../../../components/AppPagination';

import { resetEmployeesState } from '../../../slices/employeesSlice';
import { getEmployeesList } from '../../../actions/employeesActions';

const defaultFilter = {
  identityNumber: '',
  name: '',
  firstLastName: '',
  secondLastName: '',
  email: '',
};

const styles = {
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.5rem'
  }
}

const Employees = () => {
  const dispatch = useDispatch();
  const employees = useSelector(state => state.employees.list);
  
  
  const [filter, setFilter] = useState({ ...defaultFilter });
  const [pagination, setPagination] = useState({ page: 1 });

  useEffect(() => {
    setPagination({ page: 1 });
    return () => dispatch(resetEmployeesState());
  }, []);

  useEffect(() => {
    const f = { page: pagination.page };

    filter.identityNumber.length > 0 ? f.identityNumber = filter.identityNumber : null;
    filter.name.length > 0 ? f.name = filter.name : null;
    filter.firstLastName.length > 0 ? f.firstLastName = filter.firstLastName : null;
    filter.secondLastName.length > 0 ? f.secondLastName = filter.secondLastName : null;

    dispatch(getEmployeesList({ query: f }));
  }, [pagination]);

  const handleChange = e => setFilter({ ...filter, [e.target.name]: e.target.value });

  const onSubmit = e => {
    e.preventDefault();
    setPagination({ page: 1 });
  }

  const onClear = () => setFilter({ ...defaultFilter });

  const nextPage = () => setPagination({ page: pagination.page + 1 });
  const prevPage = () => setPagination({ page: Math.max(pagination.page - 1, 1) });

  return (
    <>
      <Helmet>
        <title>Cristopher | Empleados</title>
      </Helmet>
      <Box sx={styles.title}>
        <Typography variant="h5" fontWeight="bold">Empleados</Typography>
        <Button component={Link} to="cargar">Cargar</Button>
      </Box>
      <EmployeesFilter {...filter} onChange={handleChange} onSubmit={onSubmit} onClear={onClear} />
      <EmployeesListTable employees={employees} />
      <AppPagination page={pagination.page} prev={prevPage} next={nextPage} />
    </>
  );
}

export default Employees;
